import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Container, Row, Col } from 'reactstrap';
import './login.css';
import APIRequest from '../../helpers/APIRequest';
import { Link } from 'react-router-dom'


class Validation extends Component {

  constructor(props) {
    super(props);
    this.state = {
      activate: 'running'
    };
  }

  componentWillMount () {
    console.log('componentWillMount', this.props.userId);
    APIRequest.post(`users/${this.props.userId}/validation/${this.props.activationKey}`).then(res => {
      this.setState({activate: 'sucess'});
    }).catch(error => this.setState({activate: 'failed', message: error.message}));
  }

  render () {

    return (
      <div className="login-page bg-dark">

        <div className="login-wrapper">

          <div className="login-wrapper-inner">
            <Container>
              <Row>
                <Col sm="12" md="7">
                  <object aria-label="logo" className="logo" type="image/svg+xml" data="/qcats12b.svg" alt="logo" style={{float: 'left', height: '80px', width: '80px', marginRight: '.5rem', marginTop: '.8rem'}}/>
                  <h1 className="login-title text-light display-4 mb-0">Quantum CATS</h1>
                  <h4 className="login-title-subheader text-light mb-4">Code Analystics Tools & Simulations</h4>
                  <p className="login-text text-secondary">Quantum CATS is a web application for experimenters that allows you to perform quantum calculations,
                  analyze results, store and reuse information.</p>
                </Col>
                <Col>
                  <div className="login-box">
                    {this.state.activate === 'running' ?
                      <p className="alert alert-info mb-0">Validation in progress...</p>
                    : null}

                    {this.state.activate === 'failed' ?
                      <div className="alert alert-danger mb-0">
                        <p>Activation failed...</p>
                        <p>{this.state.message}</p>
                      </div>

                    : null}
                    {this.state.activate === 'sucess' ?
                      <div className="alert alert-success mb-0">
                        <p>Validation succeeded !</p>
                        <Link className="alert-link" to={'/login'}>A mail has been send to a manager to activate your account.</Link>
                      </div>
                    : null }
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
      </div>
    )
  }
}

Validation.propTypes = {
}

// These props come from the application's
// state when it is started
const mapStateToProps = (state, ownProps) => ({
  ...ownProps.match.params
})

export default connect(mapStateToProps)(Validation)



// WEBPACK FOOTER //
// ./src/containers/login/validation.js